import * as React from "react";
import Traveler from "assets/images/traveler.png";
import styles from "./styles.module.scss";

const Greeting = () => (
  <div className={styles.greetings}>
    <h2>Разрешите нам использовать ваше текущее местоположение</h2>
    <p className={styles.description}>
      Это поможет нам найти более подходящий маршрут для Вашей поездки
    </p>
    <img className={styles.image} src={Traveler} alt="Traveler" />
  </div>
);

export default Greeting;
